import {
  getAvailableSegment as coreGetAvailableSegment,
  getAvailableSegments as coreGetAvailableSegments,
} from '@revelio/core';

import type { PrimaryFilterId } from '../../../filters/types/filters';
import type { ChartType } from '../../PageConfigProvider/types/chart';
import type { MetricValues } from '../../PageConfigProvider/types/metric';
import { PRIMARY_FILTER_TO_ENTITY_TYPE } from './metric-mapping';

type GetAvailableSegmentProps = {
  chartType?: ChartType;
  primaryFilterId: PrimaryFilterId;
  metric?: MetricValues;
  activitiesEnabled?: boolean;
};

const normalizeSegmentMetric = (metric: MetricValues): MetricValues =>
  metric === 'share_of_headcount' ? 'headcount' : metric;

const withoutDisabledSegments = <T extends { value: string }>(
  options: T[],
  activitiesEnabled: boolean
): T[] =>
  activitiesEnabled
    ? options
    : options.filter((option) => option.value !== 'activities');

export const getAvailableSegment = ({
  chartType,
  primaryFilterId,
  metric,
  activitiesEnabled = false,
}: GetAvailableSegmentProps) => {
  const entityType = PRIMARY_FILTER_TO_ENTITY_TYPE[primaryFilterId];
  if (!entityType) return [];
  return withoutDisabledSegments(
    coreGetAvailableSegment({
      entityType,
      chartType,
      metric: metric === undefined ? undefined : normalizeSegmentMetric(metric),
    }),
    activitiesEnabled
  );
};

type GetAvailableSegmentsProps = Omit<GetAvailableSegmentProps, 'metric'> & {
  metrics?: MetricValues[];
};

export const getAvailableSegments = ({
  chartType,
  primaryFilterId,
  metrics,
  activitiesEnabled = false,
}: GetAvailableSegmentsProps) => {
  const entityType = PRIMARY_FILTER_TO_ENTITY_TYPE[primaryFilterId];
  if (!entityType) return [];
  return withoutDisabledSegments(
    coreGetAvailableSegments({
      entityType,
      chartType,
      metrics: metrics?.map(normalizeSegmentMetric),
    }),
    activitiesEnabled
  );
};
